import { render } from "./InvestmentPlanV2.vue?vue&type=template&id=f16b2606&scoped=true"
import script from "./InvestmentPlanV2.vue?vue&type=script&lang=js"
export * from "./InvestmentPlanV2.vue?vue&type=script&lang=js"

import "./InvestmentPlanV2.vue?vue&type=style&index=0&id=f16b2606&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f16b2606"]])

export default __exports__